/** FX-PORT: sample 4 ฝ่ามือทองคำ (glyph circle, palm flash, ground shockwave, dust) on ฝ่ามือระฆังส่งคลื่น (pp-wave). */
import { portSample } from './sampleArt/fromSample';

portSample('palm', { skills: ['pp-wave'], on: true, pre: 0.15, hit: 0.9, end: 1.7 });
